import './ContactInfo.css';

function ContactInfo() {
  return (
    <div className="contact-info">
      <h2>Our Address</h2>
      <p className="subtitle">Get your air conditioner unit serviced today!</p>

      <div className="info-item">
        <div className="info-icon">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
            <circle cx="12" cy="10" r="3"></circle>
          </svg>
        </div>
        <div className="info-content">
          <h3>Address :</h3>
          <p>Sky Breeze AC Solutions</p>
          <p>22, 4th Cross, Ramalingam Colony, KK Pudur(Po), Coimbatore - 641038.</p>
        </div>
      </div>

      <div className="info-item">
        <div className="info-icon">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
          </svg>
        </div>
        <div className="info-content">
          <h3>Phone :</h3>
          <h5>Project Booking / Repair</h5>
          <p>9384177714<br />9486077714</p>
          <h5>Institute Enquiry</h5>
          <p>9488077714</p>
        </div>
      </div>

      <div className="info-item">
        <div className="info-icon">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
  <path d="M6 2h9l5 5v13a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2
           M14 2v6h6
           M8 11h8
           M8 15h8
           M8 19h5" />
</svg>

        </div>
        <div className="info-content">
          <h3>GSTIN :</h3>
          <p>33CPFPP1767K1ZK</p>
        </div>
      </div>

      <div className="info-item">
        <div className="info-icon">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
            <polyline points="22,6 12,13 2,6"></polyline>
          </svg>
        </div>
        <div className="info-content">
          <h3>Email :</h3>
          <p>skybreezeacsolutions@gmail.com</p>
          <p>skybreezeacademy@gmail.com</p>
        </div>
      </div>

      <div className="social-media">
        <h3>Follow Us:</h3>
        <div className="social-icons">

          <div className="social-icons">
  {/* Facebook */}
  <a
    href="https://www.facebook.com/profile.php?id=61587039728926"
    target="_blank"
    rel="noopener noreferrer"
    className="social-icon"
    aria-label="Facebook"
  >
    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
      <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
    </svg>
  </a>

  {/* Instagram */}
  <a
  href="https://www.instagram.com/skybreezeacsolutions2026/"
  target="_blank"
  rel="noopener noreferrer"
  className="social-icon"
  aria-label="Instagram"
>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M7 2C4.243 2 2 4.243 2 7v10c0 2.757 2.243 5 5 5h10c2.757 0 5-2.243 5-5V7c0-2.757-2.243-5-5-5H7zm10 2c1.654 0 3 1.346 3 3v10c0 1.654-1.346 3-3 3H7c-1.654 0-3-1.346-3-3V7c0-1.654 1.346-3 3-3h10zm-5 3a5 5 0 100 10 5 5 0 000-10zm0 2a3 3 0 110 6 3 3 0 010-6zm4.5-.75a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5z"/>
  </svg>
</a>


  {/* LinkedIn */}
  <a
    href="https://www.linkedin.com/in/prakash-shanmugaraj-141a8b355/"
    target="_blank"
    rel="noopener noreferrer"
    className="social-icon"
    aria-label="LinkedIn"
  >
    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
      <path d="M4.98 3.5C4.98 4.88 3.86 6 2.48 6S0 4.88 0 3.5 1.12 1 2.5 1s2.48 1.12 2.48 2.5zM.5 8h4v16h-4V8zm7.5 0h3.8v2.2h.05c.53-1 1.82-2.2 3.75-2.2 4 0 4.75 2.6 4.75 6v10h-4v-9c0-2.1-.04-4.8-3-4.8s-3.5 2.3-3.5 4.6v9.2h-4V8z"/>
    </svg>
  </a>
</div>


        </div>
      </div>
    </div>
  );
}

export default ContactInfo;
